import { privateRoutes } from "@/routes";

// Define a type for nested route objects
type RouteValue = string | { [key: string]: RouteValue };
type RoutesObject = Record<string, RouteValue>;

// Utility to extract all route strings from a nested routes object
export function extractRoutes(routes: RoutesObject): string[] {
  const allRoutes: string[] = [];

  const traverse = (obj: RoutesObject | RouteValue): void => {
    if (typeof obj === "string") {
      allRoutes.push(obj);
      return;
    }

    if (obj && typeof obj === "object") {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          traverse(obj[key]);
        }
      }
    }
  };

  traverse(routes);
  return allRoutes;
}

// MODULE LEVEL - runs once when file is imported
const PRIVATE_ROUTES_CACHE = extractRoutes(privateRoutes);

export function matchRoute(pathname: string, routePattern: string) {
  // Replace dynamic segments like :id, :userId, etc. with regex pattern
  const regexPattern = routePattern
    .replace(/:[^/]+/g, "[^/]+") // Replace :param with [^/]+ (matches any non-slash characters)
    .replace(/\//g, "\\/"); // Escape forward slashes for regex

  const regex = new RegExp(`^${regexPattern}$`);
  return regex.test(pathname);
}

// Function to check if current pathname matches any of the private routes
export function isInPrivateRoute(pathname: string) {
  return PRIVATE_ROUTES_CACHE.some((route) => matchRoute(pathname, route));
}
